/** 集市任务 */
export interface Task {
  id: number
  /** 任务类型 1消耗金币 2邀请好友 3玩家售卖圣诞树 4其他玩家售卖圣诞树 5vip经验 */
  type: number
  celebration: number
  condition: number
  progress: number
  /** 集市任务状态 0进行中 1待领取 2已领取 */
  status: 0 | 1 | 2
  tree: number
}

/** 集市任务 DVO */
export interface ViewTask extends Task {
  name: string
  statusText: string
}

/** 圣诞集市数据 */
export interface MarketData {
  /** 圣诞币数量 */
  coin: number
  /** 圣诞树收购价 */
  price: number
  /** 圣诞树数量 */
  tree: number
  /** 今日可收购数量 */
  overage: number
  /** 今日总收购数量 */
  total: number
  /** 累计任务列表 */
  tasks: Task[]
  viewTasks: ViewTask[]
  isReward: boolean
}

export function getDefaultMarketData(): MarketData {
  return {
    coin: 0,
    price: 0,
    tree: 0,
    overage: 0,
    total: 0,
    tasks: [],
    viewTasks: [],
    isReward: false,
  }
}

export default {
  ...getDefaultMarketData(),
} as MarketData
